import ReactiveRecord, { Model } from 'reactiverecord';

class BidSearch extends Model {
  static routes = {
    only: 'show',
    show: '/api/v1/employers/projects/:project_id/bids/search',
  };
  static DEFAULT_ORDER = 'relevancy_score';
  static DEFAULT_RADIUS = 30;
  static orderOptions = {
    relevancy_score: 'Relevance',
    submitted_at: 'Oldest » Newest',
    submitted_at_desc: 'Newest » Oldest',
  };

  static schema = {
    aggregations: Object,
    bids: Array,
    expertises: Array,
    industries: Array,
    location: String,
    order: String,
    page: Number,
    pagination: Object,
    per: Number,
    project_id: Number,
    project_title: String,
    q: String,
    radius: String,
    save_for_later: Boolean,
    status: String,
    total: Number,
  };
}

export default ReactiveRecord.model('BidSearch', BidSearch);
